import { css } from '@emotion/core';

const commonAlertStyles = (theme) => {

  // Keps the dark elements of an all the same color. Hover design TBD.
  function hardCodeColors(color){
    return `
    border-color: ${color};

    & button:not(:hover) .vds-icon use {
      fill: ${color} !important;
    }
    `
  }

  return css`
    color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
    border-width: 0.1px;
    border-style: solid;
    border-bottom-width: 4px;

    &.vds-alert--error {
      ${hardCodeColors(theme?.cybs?.base?.wcag21?.romaRed ?? '#B3202A')}
    }
    &.vds-alert--warning {
      ${hardCodeColors(theme?.cybs?.base?.wcag21?.amberOrange ?? '#9B6603')}
    }
    &.vds-alert--success {
      ${hardCodeColors(theme?.cybs?.base?.wcag21?.collardGreen ?? '#2D6C4B')}
    }
    &.vds-alert--information {
      ${hardCodeColors(theme?.cybs?.base?.wcag21?.midnightBlue ?? '#021E4C')}
    }
  `
}

const styles = (theme, top, left) => ({
  containerClass: css`
    ${
      theme && theme.classes
        ? theme.classes.structure.padding.space.left[2]
        : 'padding-left: 1rem;'
    }
    ${
      theme && theme.classes
        ? theme.classes.structure.padding.space.right[2]
        : 'padding-right: 1rem;'
    }
    ${
      theme && theme.classes
        ? theme.classes.structure.padding.none.top
        : 'padding-top:0;'
    }
    ${
      theme && theme.classes
        ? theme.classes.structure.padding.none.bottom
        : 'padding-bottom:0;'
    }
    display: block;

    & .vds-alert-label {
      width: 100%;
    }

    & .vds-btn-icon svg.vds-icon {
      width: 1rem;
      height: 1rem;
    }
  `,
  toast: css`
    width: -webkit-fill-available !important;
    position: absolute !important;
    margin-left: ${left};
    margin-top: ${top};
    padding: 0.75rem 0 !important;

    &.vds-state--show {
      top: 0 !important;
    }

    ${commonAlertStyles(theme)}
  `,
  inline: css`
    padding: 0.75rem 0 !important;

    &:focus {
      outline: 1px dashed ${theme?.vds?.focusOutlineColor ?? '#15195a'};
    }

    div&.vds-alert {
      z-index: 1;
      top: 0;
    }

    ${commonAlertStyles(theme)}
  `,
  flex: css`
    flex: 1;
    margin-bottom: 0;
    margin-right: 2rem;

    & .vds-alert-label-title {
      font-size: 1rem;
    }
  `,
  closeButton: css`
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-1rem, 0.25rem);
    transform: translate(-1rem, calc(0.25rem + 2px));
    width: auto !important;
  `,
  tooltip: css`
    &.vds-tooltip {
      z-index: 402;
    }
  `
});

export default styles;
